import { Expose, Type } from 'class-transformer';
import ViewCartItemExtendedDto from './view-cart-item-extended.dto';
import ViewCartDto from './view-cart.dto';

export default class ViewCartExtendedDto extends ViewCartDto {
  @Expose()
  @Type(() => ViewCartItemExtendedDto)
  items: ViewCartItemExtendedDto[];
}
